module.exports = "../dist/img/product-detail-4-24.273b.jpg";